@let optionIndex = selectedIndex();
<div style="max-width: 1280px; margin: 0 auto;">
    <div class="profile-container">
        @if(!service.router.isFromApp() || optionIndex == -1){
            <div class="profile-nav">
                <div class="profile-panel f-col f-cross-center f-main-center">
                    @if(service.profile(); as user){
                        <div class="initials-container f-main-center f-cross-center gradient-vertical">
                            @let firstName = displayName()[0];
                            @let lastName = displayName()[1];
                            <h2 class="m-0 initials font-extrabold uppercase">{{((firstName.at(0)??'') + (lastName?.at(0)??''))}}</h2>
                        </div>
                        <h3 class="font-extrabold full-name text-center">{{firstName + ' ' + lastName}}</h3>
                        <p class="font-light email">{{user && user.email || ''}}</p>
                        <div class="account-type mt-8 mb-5">
                            <div class="tier">
                                <p class="m-0 uppercase font-bold">
                                    {{service.auth.userPackage() | humanize}} account
                                </p>
                            </div>
                        </div>
                        <div class="px-20 w-full p-inset mb-10">
                            @if(!service.auth.isPrepaidYearly() && ['free','monthly'].includes(service.auth.userPackage())){
                                <a mat-raised-button class="premium-horizontal w-full" [routerLink]="['/premium']">GET PREMIUM</a>
                            }
                             @if(service.auth.userPackage() == 'yearly' && (!user.membership || user.membership.recurs == false)){
                                 <a mat-raised-button class="premium-horizontal w-full" routerLink="/profile/account">RENEW</a>
                             } @else if(!service.auth.isFree() && user.membership && user.membership.expiry){
                                <div class="rebill">
                                    <p class="m-0">{{user.membership.recurs || user.membership.next_transaction ? 'Next renewal date' : 'Expires on'}}: {{user.membership.expiry | date: 'd/M/yyyy'}}</p>
                                </div>
                            }
                        </div>
                        @if(user.stats && user.stats[0]; as stat){
                            <div class="profile-stats display-flex f-col f-main-between f-cross-start p-10 p-inset mb-10">
                                <div class="absolute gradient-vertical"></div>
                                <div>
                                    <h3 class="font-regular my-0">All Time</h3>
                                    <div class="my-20">
                                        <small class="m-0">Savings so far</small>
                                        <h1 class="mt-0" style="margin-bottom: -6px;">€{{stat.offers.total_savings | number:'1.2'}}</h1>
                                        <small class="smaller">Estimated</small>
                                    </div>
                                </div>
                                <h3 class="my-0 font-light">
                                    {{stat.offers.total_redemptions}}
                                    <small class="smaller font-regular">redemptions</small>
                                </h3>
                            </div>
                        }
                    } @else {
                        <ng-container *ngTemplateOutlet="loader"></ng-container>
                    }
                </div>
                @if(size.width() >= 760){
                    <div class="profile-list">
                        @for(option of optionMenu; let i = $index; track option.id;){
                            <a class="pl-item" [class.selected]="optionIndex == i" [class.hidden]="option.hidden" (click)="preNavigate(option)">
                                @if(option.icon){
                                    <mat-icon [svgIcon]="option.icon"></mat-icon>
                                } @else {
                                    <mat-icon>{{option._icon||''}}</mat-icon>
                                }
                                <p class="font-{{optionIndex == i ? 'bold' : 'lite'}}">{{option.title}}</p>
                            </a>
                        }
                    </div>
                }
            </div>
        }
        @let tabs = [tabDetails,tabPreferences,tabHandle,tabReferrals,tabCoupons,tabSubscriptions,tabBilling,tabRedemptions];
        @if(size.width() >= 760){
            <div class="profile-content">
                <ng-container *ngTemplateOutlet="tabWrapper; context: { $implicit: tabs[optionIndex], index: optionIndex, main: true }"></ng-container>
            </div>
        } @else {
            <div class="profile-tabber" >
                <mat-tab-group [selectedIndex]="optionIndex+1" [dynamicHeight]="true">
                    <mat-tab> 
                        <ng-template matTabContent>
                            @for(option of optionMenu; let i = $index; track option.id){
                                @if(!option.hidden){
                                    <div class="pl-item" (click)="preNavigate(option);" [class.selected]="optionIndex == i">
                                        @if(option.icon){
                                            <mat-icon [svgIcon]="option.icon"></mat-icon>
                                        } @else {
                                            <mat-icon>{{option._icon||''}}</mat-icon>
                                        }
                                        <p>{{option.title}}</p>
                                    </div>
                                }
                            }
                        </ng-template>
                    </mat-tab>
                    @for(tab of tabs; let i = $index; track i){
                        <mat-tab>
                            <ng-template matTabContent>
                                <ng-container *ngTemplateOutlet="tabWrapper; context: { $implicit: tab, index: i }"></ng-container>
                            </ng-template>
                        </mat-tab>
                    }
                </mat-tab-group>
            </div>
        }
    </div>
</div>

<ng-template #tabWrapper let-child let-index="index" let-showTitle="main">
    @let optionDetails = optionMenu[index] || { title: 'cloudigo | Profile', _icon: 'profile' };
    @if(showTitle){
        <div class="pl-header">
            @if(optionDetails.icon){
                <mat-icon [svgIcon]="optionDetails.icon"></mat-icon>
            } @else {
                <mat-icon>{{optionDetails._icon||''}}</mat-icon>
            }
            <h1 class="font-extrabold m-0">{{optionDetails.title}}</h1>
        </div>
    } @else {
        <div class="pl-header-sm">
            <button mat-icon-button (click)="preNavigate(null)"><mat-icon>chevron_left</mat-icon></button>
            <h2 class="font-extrabold m-0">{{optionDetails.title}}</h2>
        </div>
    }
    <div class="pl-content">
        <ng-container *ngTemplateOutlet="child"></ng-container>
        <ng-content></ng-content>
    </div>
</ng-template>

<ng-template #tabDetails>
    @if(service.profile(); as user){
        <profile-details/>
    } @else {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
    }
</ng-template>

<ng-template #tabPreferences>
    @if(service.profile(); as user){
        <profile-preferences/>
    } @else {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
    }
        
</ng-template>

<ng-template #tabHandle>
    <profile-account/>
</ng-template>

<ng-template #tabReferrals>
    <!-- <profile-referrals/> -->
</ng-template>

<ng-template #tabCoupons>
    <profile-coupons/>
</ng-template>

<ng-template #tabSubscriptions>
    <profile-subscriptions/>
</ng-template>

<ng-template #tabBilling>
    <profile-billing/>
</ng-template>

<ng-template #tabRedemptions>
    <profile-redemptions/>
</ng-template>


<ng-template #loader>
    <div class="svg-loader f-main-center f-cross-center">
        <object data="old/cloudigo_loader.svg" type="image/svg+xml"></object>
    </div>
</ng-template>